import { UserPermissions } from 'interfaces';
import React from 'react';

import { useUserProfile } from './ProvideUserProfile';
import { useCompanyConfig } from '@common/modules/companyConfig';
import { useFrameContext } from 'contexts';

interface IPermissionCheckProps {
  permission: UserPermissions;
}

const PermissionCheck: React.FC<IPermissionCheckProps> = (
  { permission, children }
) => {

  const { userProfile } = useUserProfile();

  const { frameState } = useFrameContext();
  const { demoView } = useCompanyConfig();

  console.log("frameState", frameState);
  console.log("demoView", demoView);
  console.log("userProfile", userProfile);

  if (Array.isArray(demoView?.allowedTeamIds) && demoView?.allowedTeamIds?.includes(frameState?.teamId || "")) {

    if (permission === UserPermissions.viewDemoView) {
      return <>{children}</>;
    }

    return null;
  }

  if (permission === UserPermissions.viewDemoView) {
    return null;
  }

  return (
    <>
      {
        userProfile?.permissions?.includes(permission)
          ?
          <> {children} </>
          :
          null
      }
    </>
  );
};

export default PermissionCheck;